import React from 'react';
import PropTypes from 'prop-types';
import { Notifier } from '@airbrake/browser';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      enableMonitoring:
        process.env.NODE_ENV === 'production' ||
        process.env.NODE_ENV === 'staging',
    };

    if (this.state.enableMonitoring) {
      this.airbrake = new Notifier({
        projectId: import.meta.env.VITE_AIRBRAKE_PROJECT_ID,
        projectKey: import.meta.env.VITE_AIRBRAKE_API_KEY,
      });

      /* 
        Due to lazy loading sometimes the chunk load fails without
        interfering with the userexperience, this skip is to avoid
        receiving those error messages on airbrake because this is
        not impacting any user.
      */
      this.airbrake.addFilter(notice => {
        if (notice.errors[0].type === 'ChunkLoadError') {
          return null;
        }
        notice.context.environment = process.env.NODE_ENV;
        return notice;
      });
    }
  }

  componentDidCatch(error, info) {
    // Send error to Airbrake
    if (this.state.enableMonitoring) {
      this.airbrake.notify({
        error,
        params: { info },
      });
    }
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
